module.exports = __webpack_public_path__ + "static/media/native.74002601.png";